export default __webpack_public_path__ + "static/media/download.ce4db858.svg";